<template>
  <div v-if="data.more.can_action" :class="`form-group edit-status row-action w-100 ${data.status}`">
    <!-- raw -->
    <div v-if="['raw', 'reject'].includes(data.more.can_action)" class="position-relative d-flex flex-wrap w-100">
      <Select v-if="!causeVisibility && $util.options.role != 'manufacturer'" source="user/search" type="auto" field="manufacture.user_read" placeholder="Manufacturer" :value="data.manufacturer_id || null" @changeValue="handleChangeManufacturer" class="flex-1 mr-2"></Select>
      <template v-for="(status, index) in options.statuses?.[data.more.can_action].next.status || []" :key="index">
        <a v-if="!causeVisibility && options?.statuses?.[status]?.type == 1" @click.prevent="submit(status)" href="#" class="btn btn-outline-success d-flex align-items-center">
          <span>{{ options?.statuses?.[status]?.label || options?.statuses?.[status]?.text || status }}</span>
        </a>
      </template>
      <div v-if="!causeVisibility" class="position-relative d-flex w-100 mt-2 flex-wrap">
        <a @click.prevent="causeVisibility = 're-mapping'" href="#" class="btn btn-outline-warning mr-2">
          <span>Re-mapping</span>
        </a>
        <a @click.prevent="causeVisibility = 're-design'" href="#" class="btn btn-outline-light mr-2">
          <span>Re-design</span>
        </a>
      </div>
    </div>

    <!-- some status -->
    <div v-else class="position-relative d-flex flex-wrap w-100">
      <template v-for="(status, index) in options.statuses?.[data.more.can_action].next.status || []" :key="index">
        <template v-if="!causeVisibility">
          <a v-if="options?.statuses?.[status]?.type == 1" :data="options?.statuses?.[status]?.type" @click.prevent="submit(status)" href="#" class="btn btn-outline-success d-flex align-items-center mr-2">
            <span>{{ options?.statuses?.[status]?.label || options?.statuses?.[status]?.text || status }}</span>
          </a>
          <a v-else @click.prevent="causeVisibility = status" href="#" class="btn btn-outline-light mr-2">
            <span>{{ options?.statuses?.[status]?.label || options?.statuses?.[status]?.text || status }}</span>
          </a>
        </template>
      </template>
    </div>

    <CauseRefusal v-if="causeVisibility" @changeValue="submit(causeVisibility, $event)" @hiddenVisibility="causeVisibility = false" class="mt-2" />
  </div>
</template>

<script>
import Event from '@/helper/event.js'
import CauseRefusal from './CauseRefusal.vue'

export default {
  mixins: [Event],
  components: {
    CauseRefusal
  },
  data() {
    /* prettier-ignore */
    return {
      causeVisibility: false,
      cause: null,
      submitStructure: [
        'status',
        'manufacturer_id',
        'cause'
      ],
      submited: false
    }
  },
  unmounted() {
    if (this.submited) {
      this.$emitter.emit('TableList.Refresh')
    }
  },
  computed: {
    storeId() {
      return this.config?.storeId
    },
    manufactureId() {
      return this.config?.manufactureId
    },
    manufactureIds() {
      if (this.config?.manufactureIds && this.config.manufactureIds.length > 0) return this.config.manufactureIds
      if (this.config?.manufactureId) return [this.config.manufactureId]
      return []
    },
    submitUri() {
      return `manufacture/update-status/${this.manufactureId}`
    },
    data() {
      return this.config?.data || { more: {} }
    },
    status() {
      return this.data?.status
    },
    more() {
      return this.data?.more || {}
    },
    options() {
      return this.more?.options || {}
    }
  },
  methods: {
    handleChangeManufacturer(value) {
      this.store.commit('manufacturer_id', value)
    },
    async handleChangeCause(status, value) {
      this.cause = value
      this.submited = false
      let successIds = []
      let failedItems = []
      try {
        await Promise.all(
          this.manufactureIds.map(async (id) => {
            const response = await this.$util.post(`manufacture/update-status/${id}`, { status, cause: this.cause }, this.$el)
            if (response?.status == 'success') {
              if (this.manufactureIds.length === 1) {
                this.store.commit('', response.data)
              }
              successIds.push(id)
            } else {
              failedItems.push({ id, message: response?.message || 'Update failed' })
            }
          })
        )
        if (successIds.length > 0) {
          this.causeVisibility = false
        }
        this.$emit('changeValue', { successIds, failedItems })
      } catch (err) {
        console.error(err)
      } finally {
        this.submited = true
      }
    },
    async submit(status, cause) {
      this.submited = false
      if (this.manufactureId) {
        this.submitForm(
          Object.assign({}, this.data, {
            status,
            cause
          }),
          {
            done: (response) => {
              if (response.status == 'success') {
                this.store.commit('', response.data)
                this.causeVisibility = false
              } else {
                console.log(response)
              }
            },
            finally: () => {
              this.submited = true
            }
          },
          {
            $el: this.$el
          }
        )
      } else {
        let successIds = []
        let failedItems = []
        try {
          await Promise.all(
            this.manufactureIds.map(async (id) => {
              const response = await this.$util.post(`manufacture/update-status/${id}`, { status, cause }, this.$el)
              if (response?.status == 'success') {
                successIds.push(id)
              } else {
                failedItems.push({ id, message: response?.message || 'Update failed' })
              }
            })
          )
          if (successIds.length > 0) {
            this.causeVisibility = false
          }
          this.$emit('changeValue', { successIds, failedItems })
        } catch (err) {
          console.error(err)
        } finally {
          this.submited = true
        }
      }
    }
  },
  props: {
    config: Object
  }
}
</script>
